// extracted by mini-css-extract-plugin
module.exports = {"table":"RecordsTable_table_VSfCi","audioWrap":"RecordsTable_audioWrap_3pVs0"};